import { render, staticRenderFns } from "./ModalTrialPlan.vue?vue&type=template&id=22f68017&scoped=true"
import script from "./ModalTrialPlan.vue?vue&type=script&lang=ts"
export * from "./ModalTrialPlan.vue?vue&type=script&lang=ts"
import style0 from "./ModalTrialPlan.scss?vue&type=style&index=0&id=22f68017&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f68017",
  null
  
)

export default component.exports